/**
 * 路由守卫
 */

import router from "@/router/index.js";
import store from '@/store/index.js'

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

router.beforeEach((to, from, next) => {

    if (["phoneDown", "history", "singleDown"].indexOf(to.name) === -1 && isMobile) {
        next("phoneDown");
        return;
    }
    store.commit("setMenuName", to.meta.title)

    next();
})